import { type FC } from 'react';
import {
  faArrowUpRightAndArrowDownLeftFromCenter,
  faClone,
  faXmarkLarge,
} from '@fortawesome/pro-light-svg-icons';
import type { RealizedAndImpliedVolsProps } from './types';
import RealizedAndImpliedVolsContent from './realized-and-implied-vols-content';
import { Widget } from '../../widget';

const RealizedAndImpliedVolsWidget: FC<RealizedAndImpliedVolsProps> = (props) => {
  const { widget, actions } = props;

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.Buttons>
          <Widget.Button
            icon={faArrowUpRightAndArrowDownLeftFromCenter}
            onClick={() => actions.handleMaximizeWidget(widget.id || widget.key)}
          />
          <Widget.Button
            icon={faClone}
            onClick={() => actions.handleDuplicateWidget(widget.id || widget.key)}
          />
          <Widget.Button
            icon={faXmarkLarge}
            onClick={() => actions.handleCloseWidget(widget.id || widget.key)}
          />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <RealizedAndImpliedVolsContent />
      </Widget.Content>
      <Widget.Footer></Widget.Footer>
    </Widget>
  );
};

export default RealizedAndImpliedVolsWidget;
